import { LinkButton, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './DailyrentBanner.css';

export interface IDailyrentBannerProps {
  url: string;
  onClick(): void;
}

export function DailyrentBanner(props: IDailyrentBannerProps) {
  return (
    <div className={styles['banner']} data-name="DailyrentBanner">
      <div className={styles['header']}>
        <UIHeading1 color="text-inverted-default">Заселяйтесь в отпуск</UIHeading1>
      </div>
      <div className={styles['text']}>
        <UIText1 color="text-inverted-default">Проживите отпуск по-новому там, где вы еще не были</UIText1>
      </div>
      <LinkButton theme="inverted" size="M" href={props.url} onClick={props.onClick}>
        Посмотреть
      </LinkButton>
    </div>
  );
}
